/**
 * Created by qlong on 10/5/2016.
 */
import React, {Component} from 'react'
import { Link } from 'react-router'
const baseUrl = "/cessationStability/onlineVisualization" //Change to "/SpaghettiChart" for prod deployment
export default class Footer extends Component{
    render(){
        const imgUrl = require("../../images/IDM_logo_307blue.png")
        return (
            <footer>
                {/*Qinghua Long(qlong@intven.com), Benoit Raybaud (braybaud@intven.com)<br /><br />*/}
                Copyright 2016 Intellectual Ventures Management, LLC (IVM), All Rights Reserved. &nbsp;
                <Link to={baseUrl + "/about"}>About us</Link>
                <br /><br />
                <img src={imgUrl} />
            </footer>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/